import React from 'react'

export default function Check() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
			<defs>
				<path id="a" d="M7.8 16.503L18.951 5.35A1.2 1.2 0 1 1 20.65 7.05l-12 12a1.2 1.2 0 0 1-1.698 0l-3.6-3.6A1.2 1.2 0 1 1 5.05 13.75L7.8 16.503z" />
			</defs>
			<g fill="none" fill-rule="evenodd">
				<mask id="b" fill="#fff">
					<use href="#a" />
				</mask>
				<g fill="#24206b" mask="url(#b)">
					<path d="M0 0h24v24H0z" />
				</g>
			</g>
		</svg>
	)
}
